import apiClient from 'api/apiClient';

// eslint-disable-next-line import/prefer-default-export
export const getProducts = ([productKeys]) => apiClient.get('/v1/products', {
  params: {
    productKeys,
  },
});
